import queryString from 'querystring';

import reduxCreator from '../libs/mk-womanizer/redux-creator';
import axiosPlugin from "../libs/mk-womanizer/ac-axios-plugin";


let redux = reduxCreator.type('TIMELINE_COMMENTS').plugin(axiosPlugin, {template: "multiArray"});

let fetchCommentsAction = redux.fetchActionGet();

redux.reducerForType('ADD', (state,payload) => {
    let newState = {...state};
    newState[payload.data.parentId].data.unshift(payload.data);
    newState[payload.data.parentId].total++;
    return newState;
});

redux.reducerForType('DELETE', (state,payload) => {
    let newState = {...state};
    if(payload.data && payload.data._id){
        newState[payload.data.parentId].data = newState[payload.data.parentId].data.filter(item => item._id.toString() !== payload.data._id.toString());
        newState[payload.data.parentId].total--;
        if(newState[payload.data.parentId].total < 0){
            newState[payload.data.parentId].total = 0;
        }
    }
    return newState;
});

redux.reducerForType('UPDATE', (state,payload) => {
    let newState = {...state};
    if(payload.data && payload.data._id){
        newState[payload.data.parentId].data = newState[payload.data.parentId].data.map(item => {
            if(item._id.toString() === payload.data._id.toString()){
                item = payload.data;
            }
            return item;
        });
    }
    return newState;
});

export const fetchTimelineComments = (type, parentId,query = {}, more = false) => fetchCommentsAction(`/${type}/${parentId}/comments?${queryString.stringify(query)}`, null, {key: parentId, more});
export const resetTimelineComments = (keys) => redux.actions.unsetKeys(keys);

export const timelineComments = redux.reducer();